var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,_vm._g(_vm._b({tag:"component",class:_vm.iconClass,attrs:{"size":_vm.size,"color":_vm.color,"stroke-width":_vm.strokeWidth}},'component',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }